import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import StarRatings from 'react-star-ratings';
import { Col, Card, CardBody, Row } from "reactstrap";

import { useDispatch, useSelector } from 'react-redux'
// import {addtocard} from '../store/auth/cart/actions'
// import {cart} from "../store/auth/cart/reducer"

//TODO:hacer esto de la manera correcta
import "../../assets/scss/custom/components/product.scss"
import { addToCart } from '../../store/auth/cart/actions'
import { StoreService } from '../../services/storeService';
import toastr, { success } from 'toastr'
import { useParams } from 'react-router-dom';
import Fav from "./Fav";


export default function Product(props) {

    const user = useSelector(x => x.Login.user);
    const storeService = new StoreService()
    const dispatch = useDispatch()
    const cart = useSelector(store => store.cart.countercart);
    const [favoritos, setFavoritos] = useState([])
    //const favoritosGuardados = JSON.parse(localStorage.getItem('favoritos'))

    useEffect(() => {
        console.log(props)
        console.log("xxxxx")
        console.log(JSON.stringify(props))
    }, [])

    const selectProduct = (product) => {
        
        dispatch(addToCart(product))
        toastr.success("PRODUCTO AGREGADO EXITOSAMENTE");
    }

   return (
    <React.Fragment>
        <Col sm="4" className="h-100">
            <Card className="product-card">
                <div className="favorite">
                    <i className={props.product.favorite ? "fas fa-heart" : "far fa-heart"} aria-hidden="true"
                        onClick={() => props.toggleFavorite(props.product.id, !props.product.favorite)}></i>
                </div>
                <CardBody>
                    <div className="product-img position-relative">
                        <div className="product-image">
                            {props.product.Descuento ? (
                                <span className="productDiscount">-{props.product.Descuento}% off</span>
                            ) : null}
                            <img src={props.product.image} alt="" className="mx-auto d-block" />

                        </div>
                    </div>
                    <div className="mt-4 text-center">
                        <h5 className="mb-3 text-truncate product-name">
                            <Link to={`/detailProducts/${props.product.id}`}>
                                {props.product.name}
                            </Link>
                        </h5>
                        
                        <div className="product-store">
                            {props.product.store}
                        </div>
                        
                        <div className="mb-3">
                            <StarRatings
                                rating={props.product.rating}
                                starRatedColor="#FFD700"
                                starEmptyColor="#cccccc"
                                numberOfStars={5}
                                name='rating'
                                starDimension="14px"
                                starSpacing="3px"
                            />
                        </div>
                        
                        <h5 className="my-0">
                            <b>
                                {props.product.Descuento ? (
                                    <>
                                        <span className="product-price">{props.product.newPrice}</span>
                                        <del className="product-old-price">{props.product.lastPrice}</del>
                                    </>
                                ) : (
                                    <span className="product-price">{props.product.newPrice}</span>
                                )}
                            </b>
                        </h5>
                            
                        <Row className="mt-3">
                            <Col>
                                <Link to={`/detailProducts/${props.product.id}`} className="btn-ver-mas">
                                    Ver +
                                </Link>
                            </Col>
                        </Row>
                    </div>
                </CardBody>
            </Card>
        </Col>
    </React.Fragment>
);


}
